import React from 'react';
import { validatable } from 'components/utils';
import DonDocDoiTuong from './DonDocDoiTuong.jsx';
import DonDocDoiTuongView from './DonDocDoiTuongView.jsx';
import { Link } from 'react-router';
import { ThanhTra } from 'api';
import moment from 'moment';
import { ShowIf } from 'components/utils';

class ListDonDoc extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      id: this.props.id,
      data: [],
      dataPost: [],
      dataPatch: [],
      dataDelete: [],
      dataKetQuaThucHienDonDoc: [],
      dataHinhThucDonDoc: []
    }
  }

  componentDidMount() {
    this.props.onRef(this);
    this.getDonDocDoiTuongs();
    this.getKetQuaThucHienDonDoc();
    this.getHinhThucDonDocs();
  }

  componentWillReceiveProps(nextProps) {
    if(this.props.id != nextProps.id) {
      this.setState({
        id: nextProps.id
      }, () => {
        this.getDonDocDoiTuongs();
      })
    }
  }

  addLanDonDoc() {
    let newItem = {
      coQuanBanHanhCuongChe: '',
      coQuanBanHanhHuyCuongChe: '',
      doiTuongViPham: '',
      ghiChu: '',
      hinhThucCuongChe: '',
      hinhThucDonDoc: null,
      huyCuongChe: false,
      ketQuaThucHien: null,
      ngayBanHanh: '',
      ngayBanHanhCuongChe: '',
      ngayBanHanhHuyCuongChe: '',
      ngayBatDauDonDoc: '',
      ngayHetHanDonDoc: '',
      soQuyetDinhCuongChe: '',
      soQuyetDinhHuyCuongChe: '',
      soTienCuongChe: '',
      soVanBan: '',
      thoiGianThucHienCuongChe: '',
      thoiGianThucHienHuyCuongChe: '',
      thoiHanDonDoc: '',
      thoiHanNgayLamViecDonDoc: '',
      tinhHinhTienDoThucHienCuongChe: '',
      tinhHinhTienDoThucHienKetLuan: '',
      toChucTinDungThucHienCuongChe: '',
      toChucTinDungThucHienHuyCuongChe: ''
    }
    this.setState({
      dataPost: [
        ...this.state.dataPost,
        newItem
      ]
    }, () => {
      if(this.state.data.length > 0 || this.state.dataPost.length > 1) {
        this.props.onChangeData();
      }
    })

  }

  getDonDocDoiTuongs() {
    let params={
      doiTuongViPhamId: this.state.id
    }
    ThanhTra.actions.donDocDoiTuongs.request(params).then(res => {
      if(res.data._embedded) {
        this.setState({
          data: res.data._embedded.donDocDoiTuongs
        })
      } else {
        this.addLanDonDoc();
      }
    })
  }

  getKetQuaThucHienDonDoc() {
    ThanhTra.actions.ketQuaThucHienDonDoc.request().then(res => {
      if(res.data) {
        this.setState({
          dataKetQuaThucHienDonDoc: res.data
        })
      }
    })
  }

  getHinhThucDonDocs() {
    ThanhTra.actions.hinhThucDonDocs.request().then(res => {
      if(res.data) {
        this.setState({
          dataHinhThucDonDoc: res.data
        })
      }
    })
  }

  onChangeData(state, id) {
    let data = [...this.state.dataPatch];

    let index = data.findIndex(x => x.donDocDoiTuongId == id);
    if (index == -1) {
      this.setState({
        dataPatch: [
          ...this.state.dataPatch,
          state
        ]
      })
    } else {
      this.state.dataPatch[index] = state;
      this.setState({
        dataPatch: this.state.dataPatch
      })
    }
    this.props.onChangeData();
  }

  onChangeDataPost(data, index) {
    this.state.dataPost[index] = data;
    this.setState({
      dataPost: this.state.dataPost
    })
    this.props.onChangeData();
  }

  onRemoveData(index, id) {
    let newData = [...this.state.data];

    newData.splice(index, 1);
    this.state.data = newData;
    let itemDelete = {
      id: id
    }
    this.setState({
      data: this.state.data,
      dataDelete: [
        ...this.state.dataDelete,
        itemDelete
      ]
    })
    this.props.onChangeData();
  }

  onRemoveDataPost(index) {
    let newData = [...this.state.dataPost];
    newData.splice(index, 1);
    this.state.dataPost = newData;
    this.setState({
      dataPost: this.state.dataPost
    })
    this.props.onChangeData();
  }

  handleSave(callback) {
    this.postDonDoc(() => {
      this.patchDonDoc(() => {
        this.deleteDonDoc(() => {
          callback();
        })
      });
    });
  }

  componentWillUnmount() {
    this.props.onRef(undefined)
  }

  patchDonDoc(callback) {
    if(this.state.dataPatch.length > 0) {
      let donDocDoiTuongPatch = []
      this.state.dataPatch.map(item => {
        let itemPost = item;
        if(itemPost.ngayBanHanh) {
          itemPost.ngayBanHanh = moment(new Date(itemPost.ngayBanHanh)).add(7, 'hours').toISOString();
        } else {
          itemPost.ngayBanHanh = null
        }
        if(itemPost.ngayBanHanhCuongChe) {
          itemPost.ngayBanHanhCuongChe = moment(new Date(itemPost.ngayBanHanhCuongChe)).add(7, 'hours').toISOString();
        } else {
          itemPost.ngayBanHanhCuongChe = null
        }
        if(itemPost.ngayBanHanhHuyCuongChe) {
          itemPost.ngayBanHanhHuyCuongChe = moment(new Date(itemPost.ngayBanHanhHuyCuongChe)).add(7, 'hours').toISOString();
        } else {
          itemPost.ngayBanHanhHuyCuongChe = null
        }
        if(itemPost.ngayBatDauDonDoc) {
          itemPost.ngayBatDauDonDoc = moment(new Date(itemPost.ngayBatDauDonDoc)).add(7, 'hours').toISOString();
        } else {
          itemPost.ngayBatDauDonDoc = null
        }
        if(itemPost.ngayHetHanDonDoc) {
          itemPost.ngayHetHanDonDoc = moment(new Date(itemPost.ngayHetHanDonDoc)).add(7, 'hours').toISOString();
        } else {
          itemPost.ngayHetHanDonDoc = null
        }
        if(itemPost.thoiGianThucHienCuongChe) {
          itemPost.thoiGianThucHienCuongChe = moment(new Date(itemPost.thoiGianThucHienCuongChe)).add(7, 'hours').toISOString();
        } else {
          itemPost.thoiGianThucHienCuongChe = null
        }
        if(itemPost.thoiGianThucHienHuyCuongChe) {
          itemPost.thoiGianThucHienHuyCuongChe = moment(new Date(itemPost.thoiGianThucHienHuyCuongChe)).add(7, 'hours').toISOString();
        } else {
          itemPost.thoiGianThucHienHuyCuongChe = null
        }

        itemPost.ketQuaThucHien = itemPost.ketQuaThucHien ? itemPost.ketQuaThucHien : null;
        itemPost.hinhThucDonDoc = itemPost.hinhThucDonDoc ? itemPost.hinhThucDonDoc : null;

        itemPost.doiTuongViPham = {
          id: Number(this.state.id)
        }

        donDocDoiTuongPatch[donDocDoiTuongPatch.length] = itemPost
      })
      let params = {
        donDocDoiTuongs: [
          ...donDocDoiTuongPatch
        ]
      };
      ThanhTra.actions.patchDonDoc.request('', params).then(res => {
        callback();
      }).catch(err => {})
    } else {
      callback();
    }
  }
  postDonDoc(callback) {
    if(this.state.dataPost.length > 0) {
      let donDocDoiTuongs = []
      this.state.dataPost.map(item => {
        let itemPost = item;
        if(itemPost.ngayBanHanh) {
          itemPost.ngayBanHanh = moment(new Date(itemPost.ngayBanHanh)).add(7, 'hours').toISOString();
        } else {
          itemPost.ngayBanHanh = null
        }
        if(itemPost.ngayBanHanhCuongChe) {
          itemPost.ngayBanHanhCuongChe = moment(new Date(itemPost.ngayBanHanhCuongChe)).add(7, 'hours').toISOString();
        } else {
          itemPost.ngayBanHanhCuongChe = null
        }
        if(itemPost.ngayBanHanhHuyCuongChe) {
          itemPost.ngayBanHanhHuyCuongChe = moment(new Date(itemPost.ngayBanHanhHuyCuongChe)).add(7, 'hours').toISOString();
        } else {
          itemPost.ngayBanHanhHuyCuongChe = null
        }
        if(itemPost.ngayBatDauDonDoc) {
          itemPost.ngayBatDauDonDoc = moment(new Date(itemPost.ngayBatDauDonDoc)).add(7, 'hours').toISOString();
        } else {
          itemPost.ngayBatDauDonDoc = null
        }
        if(itemPost.ngayHetHanDonDoc) {
          itemPost.ngayHetHanDonDoc = moment(new Date(itemPost.ngayHetHanDonDoc)).add(7, 'hours').toISOString();
        } else {
          itemPost.ngayHetHanDonDoc = null
        }
        if(itemPost.thoiGianThucHienCuongChe) {
          itemPost.thoiGianThucHienCuongChe = moment(new Date(itemPost.thoiGianThucHienCuongChe)).add(7, 'hours').toISOString();
        } else {
          itemPost.thoiGianThucHienCuongChe = null
        }
        if(itemPost.thoiGianThucHienHuyCuongChe) {
          itemPost.thoiGianThucHienHuyCuongChe = moment(new Date(itemPost.thoiGianThucHienHuyCuongChe)).add(7, 'hours').toISOString();
        } else {
          itemPost.thoiGianThucHienHuyCuongChe = null
        }

        itemPost.ketQuaThucHien = itemPost.ketQuaThucHien ? itemPost.ketQuaThucHien : null;
        itemPost.hinhThucDonDoc = itemPost.hinhThucDonDoc ? itemPost.hinhThucDonDoc : null;

        itemPost.doiTuongViPham = {
          id: Number(this.state.id)
        }

        donDocDoiTuongs[donDocDoiTuongs.length] = itemPost
      })
      let params = {
        donDocDoiTuongs
      };

      ThanhTra.actions.postDonDoc.request('', params).then(res => {
        callback();
      }).catch(err => {})
    } else {
      callback();
    }
  }
  deleteDonDoc(callback) {
    if(this.state.dataDelete.length > 0) {
      let params = {
        donDocDoiTuongs: [
          ...this.state.dataDelete
        ]
      };
      ThanhTra.actions.deleteDonDoc.request('', params).then(res => {
        callback();
      }).catch(err => {})
    } else {
      callback();
    }
  }

  render() {
    return (
      <div className='pl15 pr15'>
        <ShowIf condition={this.props.view != true}>
          <div>
            {
              this.state.data.map((item, index) => {
                if(this.state.dataPost.length == 0 && (index == this.state.data.length - 1)) {
                  return <DonDocDoiTuong toChucLienQuan={this.props.toChucLienQuan} {...item} dataDetail={item} doiTuongViPhamId={this.state.id} key={index} indexItem={index} enableDelete={true} countItem={this.state.data.length + this.state.dataPost.length} bindValidator={this} index={index} onRemove={this.onRemoveData.bind(this)} onChange={this.onChangeData.bind(this)} dataHinhThucDonDoc={this.state.dataHinhThucDonDoc} dataKetQuaThucHienDonDoc={this.state.dataKetQuaThucHienDonDoc}/>
                } else {
                  return <DonDocDoiTuong toChucLienQuan={this.props.toChucLienQuan} {...item} dataDetail={item} doiTuongViPhamId={this.state.id} key={index} indexItem={index} countItem={this.state.data.length + this.state.dataPost.length} bindValidator={this} index={index} onRemove={this.onRemoveData.bind(this)} onChange={this.onChangeData.bind(this)} dataHinhThucDonDoc={this.state.dataHinhThucDonDoc} dataKetQuaThucHienDonDoc={this.state.dataKetQuaThucHienDonDoc}/>
                }
              })
            }
            {
              this.state.dataPost.map((item, index) => {
                if(index == (this.state.dataPost.length - 1)) {
                  return <DonDocDoiTuong toChucLienQuan={this.props.toChucLienQuan} {...item} dataDetail={item} doiTuongViPhamId={this.state.id} key={index} indexItem={index} enableDelete={true} countItem={this.state.data.length + this.state.dataPost.length} bindValidator={this} index={this.state.data.length + index} onRemove={this.onRemoveDataPost.bind(this)} onChange={this.onChangeDataPost.bind(this)} dataHinhThucDonDoc={this.state.dataHinhThucDonDoc} dataKetQuaThucHienDonDoc={this.state.dataKetQuaThucHienDonDoc}/>
                } else {
                  return <DonDocDoiTuong toChucLienQuan={this.props.toChucLienQuan} {...item} dataDetail={item} doiTuongViPhamId={this.state.id} key={index} indexItem={index} countItem={this.state.data.length + this.state.dataPost.length} bindValidator={this} index={this.state.data.length + index} onRemove={this.onRemoveDataPost.bind(this)} onChange={this.onChangeDataPost.bind(this)} dataHinhThucDonDoc={this.state.dataHinhThucDonDoc} dataKetQuaThucHienDonDoc={this.state.dataKetQuaThucHienDonDoc}/>
                }
              })
            }
          </div>
        </ShowIf>
        <ShowIf condition={this.props.view === true}>
          {
            this.state.data.map((item, index) => {
              return <DonDocDoiTuongView toChucLienQuan={this.props.toChucLienQuan} {...item} dataDetail={item} key={index} countItem={index + 1} index={index} dataHinhThucDonDoc={this.state.dataHinhThucDonDoc} dataKetQuaThucHienDonDoc={this.state.dataKetQuaThucHienDonDoc}/>
            })
          }
        </ShowIf>
        <ShowIf condition={this.props.view != true}>
          <div  className='mt5 mb15'><Link className='txt-green' onClick={this.addLanDonDoc.bind(this)}> <i className='tt tt-addfile'/>Thêm lần đôn đốc</Link></div>
        </ShowIf>
      </div>
    )
  }
}

export default validatable(ListDonDoc);



// WEBPACK FOOTER //
// ./src/components/modules/theo-doi-thuc-hien/sub-view/ListDonDoc.jsx